module.exports = __webpack_public_path__ + "static/media/cudy-tech__logo.fd98e90e.png";